import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dictionary from 'dictionary';
import Collapsible from 'react-collapsible';
import Masonry from 'react-masonry-component';
import { SmallScreen } from 'utils/responsive-mq';

class AboutClients extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
	}
	render() {
		if ( !this.props.list ) return null;
		const types = ['pub', 'comm', 'agency', 'fashion'];
		
		return (
			<div id="AboutClients">
				<Collapsible trigger="+ Show all" triggerWhenOpen="– Show less" transitionTime={400}>
					<SmallScreen>
						{(match) => {
							return (match)? 
								<MasonryClientLists types={types} rawList={this.props.list} /> :
								<FlexClientLists types={types} rawList={this.props.list} />;
						}}
					</SmallScreen>
				</Collapsible>
			</div>
		)
	}
}
AboutClients.propTypes = {
	list: PropTypes.array
}
const mapStateToProps = (state) => {
	return {
		collapsible_speed: state.config.collapsible_speed,
	}
}
export default connect( mapStateToProps )(AboutClients);




const FlexClientLists = ({ types, rawList }) => {
	if ( !types || !rawList ) return null;
	const lists = types.map( type => {
		const items = rawList.filter( item => item.type === type );
		const title = '(' + Dictionary.get( ['clients', type], type ) + ')';
		return <ClientList key={type} title={title} items={items} />
	} );
	return (
		<div className="FlexClientLists">
			{lists}
		</div>
	)
}

const MasonryClientLists = ({ types, rawList }) => {
	if ( !types || !rawList ) return null;
	const masonryOptions = { percentPosition: true };
	const lists = types.map( type => {
		const items = rawList.filter( item => item.type === type );
		const title = '(' + Dictionary.get( ['clients', type], type ) + ')';
		const list = <ClientList title={title} items={items} />
		const listStyle = {width: '50%'};
		return (
			<div key={type} style={listStyle}>{list}</div>
		)

	} );
	return (
		<div className="MasonryClientLists">
			<Masonry options={masonryOptions}>{lists}</Masonry>
		</div>
	)
}

const ClientList = ({title, items}) => {
	if ( !items ) return null;
	const sorted = items.sort( (a, b) => a.slug.toLowerCase().localeCompare( b.slug.toLowerCase() ) );
	const lis = sorted.map( item => <li key={item.slug}>{item.title}</li> )
	return (
		<div className="ClientList">
			<h4>{title}</h4>
			<ul>{lis}</ul>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/Pages/About/AboutClients.jsx